export { ContentSectionVariantSeven } from "./content-section-variant-seven";
